export default __webpack_public_path__ + "static/media/SectionsIcon.080b7929.svg";